import React from 'react';
import { useSelector } from 'react-redux';
import VrrTable from 'micro_front_end/shared_components/vrr_table';
import { prepareHeaders, prepareBodies } from './services';
import useSettings from '../../../../../libs/settings/useSettings';
import { getOverviewDMPreferences } from '../../../../../redux/settings/settingAction';
import { SORT_BY } from '../../../../shared_components/vrr_sort_by/constants';
import { TMetricDetailTable } from './types';
import metricDetailTableStyles from './styles/MetricDetailTable.module.scss';
import './styles/MetricDetailTable.scss';

const MetricDetailTable: React.FC<TMetricDetailTable> = ({
  headers,
  metricData,
  metric
}: TMetricDetailTable) => {
  const mainKpi: string | undefined = useSelector(
    getOverviewDMPreferences
  )?.main_kpi;
  const mainKpiSort: string | undefined = useSelector(
    getOverviewDMPreferences
  )?.main_kpi_sort;
  const { overview } = useSettings();

  const handleMainKpiPreference = (kpiName: string) => {
    overview('detailed_metrics', {
      main_kpi: kpiName.toLowerCase()
    });
  };

  const onSort = (id: string, type: string) => {
    if (id === mainKpi) {
      overview('detailed_metrics', {
        main_kpi_sort: type
      });
    }
  };

  return (
    <div className="metric-detail-modal-wrapper">
      <VrrTable
        header={prepareHeaders(
          headers,
          metric,
          mainKpi,
          handleMainKpiPreference
        )}
        body={prepareBodies(metricData, headers)}
        withSort
        defaultSort={{ id: mainKpi ?? '', type: mainKpiSort ?? SORT_BY.asc }}
        onSortAction={onSort}
        withFilter
        tableProps={{
          borderless: true,
          className: 'metric-detail-table',
          cssModule: metricDetailTableStyles
        }}
      />
    </div>
  );
};

export default MetricDetailTable;
